import { makeActionCreator } from '../../config/store/utils'
import { getContingenciesBuyerList } from '../../services/contingencies'

export const GET_CONTINGENCIES_BUYER_LIST = 'GET_CONTINGENCIES_BUYER_LIST'
export const GET_CONTINGENCIES_BUYER_LIST_ERROR = 'GET_CONTINGENCIES_BUYER_LIST_ERROR'
export const GET_CONTINGENCIES_BUYER_LIST_SUCCESS = 'GET_CONTINGENCIES_BUYER_LIST_SUCCESS'
export const onGetContingenciesBuyerList = makeActionCreator(GET_CONTINGENCIES_BUYER_LIST)
export const onGetContingenciesBuyerListError = makeActionCreator(GET_CONTINGENCIES_BUYER_LIST_ERROR, 'payload')
export const onGetContingenciesBuyerListSuccess = makeActionCreator(GET_CONTINGENCIES_BUYER_LIST_SUCCESS, 'payload')
export const onGetContingenciesBuyersListThunk = payload => async dispatch => {
  dispatch(onGetContingenciesBuyerList())

  try {
    const { data } = await getContingenciesBuyerList(payload)

    const csvStructure = data?.payload?.resultados?.map(entity => [
      entity.link,
      entity.supplierName,
      entity.supplierRut,
      entity.amountCLP,
      entity.amountUSD,
      entity.quantiyOC
    ])
    payload.callback(data?.payload?.pageCount)
    return dispatch(onGetContingenciesBuyerListSuccess({ buyers: csvStructure }))
  } catch (error) {
    return dispatch(onGetContingenciesBuyerListError(error))
  }
}
